<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Manage Packages</h3>
        <div v-for="item in packages" :key="item.id" class="post full-width">
          <b>{{ item.name }}</b>
          &nbsp; &nbsp;
          <b>${{ item.current_price }}</b>
          <br />
          <router-link
            class="sml-btn blue"
            :to="{ path: '/admin/package/' + item.id }"
          >
            Edit
          </router-link>
        </div>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    packages() {
      return this.$store.state.packages;
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManagePackages.vue?59d3f0ae